//Components
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../common/Layout';
import Wrapper from '../../common/Wrapper';
import { Grid, Button } from '@material-ui/core';
import SearchForm from '../../common/Search/SearchForm';
import Loading from '../../common/Loading';
import { RolePermissions } from '../../../domain/constants/RolePremissions';
import { Add } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { SystemActions } from '../../../domain/constants/SystemActions';
import { useSyles } from '../../common/Wrapper/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHeader from '../../common/Table/TableHeader';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { fieldsFilter, headCells, valuesEstatus } from './LoanP2PList.constants';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { getAllHousekeys } from '../../../redux/housekeys/thunks';
import { getUserLoanP2P } from '../../../redux/loans_p2p/thunks';
import LoanP2Prow from './LoanP2P.constants';
import useScan from '../../../hooks/useScan';
import { RootState } from '../../../domain/models/RootState';
import { getSorting, stableSort } from 'src/helpers/sorts';

export const LoansP2PList = (props: any) => {
  const classes = useSyles();
  const { auth } = useSelector((state: any) => state);
  const dispatch = useDispatch<any>();
  const [filter, setFilter] = useState('');
  const [firstLoad, setFirstLoad] = useState(true);
  const allowEdit = RolePermissions.allowed(
    Number(auth.type),
    SystemActions.edit_keys
  );
  const { setDestination } = useScan();
  const navigate = useNavigate(); // habilitar navigate para redirección
  //Sergio ---- ver que onda con este para traer tus prestadas
  const { loans_p2p, loading } = useSelector(
    (state: RootState) => state.loans_p2p
  );
  const [pagination, setPagination] = useState({
    rowsPerPage: 10,
    page: 1,
    total: 1,
    order: 'desc',
    orderBy: 'name',
  });
  // función que redirige generar una transferencia
  const redirectAdd = () => {
    navigate(`/p2p/loans/new`, { replace: true });
  };

  const emptyRows =
    pagination.rowsPerPage -
    Math.min(
      pagination.rowsPerPage,
      pagination.total - pagination.page * pagination.rowsPerPage
    );

  const sliceX = 0;
  const sliceY = pagination.rowsPerPage;
  const { order, orderBy } = props;
  //Fin de los filtros

  //realiza la consulta de p2p
  const updateDataByPagination = async () => {
    await dispatch(getUserLoanP2P({ filter, pagination }));
  };
  useEffect(() => {
    if (!firstLoad) {
      updateDataByPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.rowsPerPage, pagination.page]);

  useEffect(() => {
    pagination.page = 1;
    updateDataByPagination();
    setFirstLoad(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    setPagination({
      ...pagination,
      total: loans_p2p.paginate?.items ? loans_p2p.paginate.items : 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loans_p2p.paginate]);

  useEffect(() => {
    setDestination('act-l-p2p', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitFilterLoanP2P = (values: any) => {
    //preparar la data para filtrar
    if (values.key !== '' && values.name_value !== '') {
      setFilter(`&${values.key}=${values.name_value}`);
    } else {
      setFilter('');
    }
  };
  //Filtros
  const initialValuesFilter = {
    key: 'ppt.id',
    name_value: '',
  };
  const handleChangePage = (event: any, page: any) => {
    setPagination({
      ...pagination,
      page: ++page,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPagination({
      ...pagination,
      rowsPerPage: event.target.value,
    });
  };
  return (
    <Layout>
      <Wrapper
        button={allowEdit}
        buttonTitle='Agregar llave'
        actionTitle={() => redirectAdd()}
      >
        <Grid className={classes.containerHeader} container item spacing={4}>
          <Grid item xs={12} sm={8} md={8} className={classes.button}>
            <SearchForm
              submitFilter={submitFilterLoanP2P}
              fields={fieldsFilter}
              valuesEstatus={valuesEstatus}
              initialValues={initialValuesFilter}
              filter='p2p'
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} className={classes.button}>
            <Button
              size='medium'
              color='secondary'
              variant='contained'
              onClick={() => redirectAdd()}
            >
              Realizar Transferencia
              <Add />
            </Button>
          </Grid>
        </Grid>
        {!loading ? (
          <>
            {loans_p2p?.loans_p2p?.length > 0 ? (
              <div>
                <div>
                  <TableContainer component={Paper}>
                    <Table aria-label='simple table'>
                      <TableHeader cellsList={headCells} />
                      <TableBody>
                        {stableSort(
                          loans_p2p?.loans_p2p,
                          getSorting(order, orderBy)
                        )
                          .slice(sliceX, sliceY)
                          .map((loans_p2p: any) => {
                            return (
                              <LoanP2Prow
                                key={`loans_p2p-${loans_p2p.id}`}
                                loans_p2p={loans_p2p}
                              />
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 49 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 50]}
                  component='div'
                  count={pagination.total}
                  rowsPerPage={pagination.rowsPerPage}
                  page={pagination.page - 1}
                  labelRowsPerPage='Renglones por página'
                  backIconButtonProps={{
                    'aria-label': 'Anterior',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Siguiente',
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            ) : (
              <div>No hay datos</div>
            )}
          </>
        ) : (
          <Loading />
        )}
      </Wrapper>
    </Layout>
  );
};
